module.exports = __webpack_public_path__ + "media/assets/images/flags/kz-a50ebc215e72a4271d04d4b9502dcfc9.svg";